// extracted by mini-css-extract-plugin
module.exports = {"container":"notif-modal_container__2Cm5i","image":"notif-modal_image__26kf2","title":"notif-modal_title__2bBp_","content":"notif-modal_content__A49Vd"};